
import { Component, Mixins, Prop } from 'vue-property-decorator'

import CustomTagMixin from '@/@next/mixins/CustomTag'
import { CImage } from '@/@next/components/image'
import { CLoader } from '@/components/loader'
import { CButton, CButtonLabel, CButtonIcon } from '@/components/form-controls/button'
import { messages } from '@/@next/i18n'

const config = {
  name: 'c-content-media-sync',
  i18n: { messages },
  components: {
    CImage,
    CLoader,
    CButton, CButtonLabel, CButtonIcon
  }
}

@Component(config)
export default class MediaSync extends Mixins(CustomTagMixin) {
  @Prop({ type: Object, required: true }) content!: any
  @Prop({ type: String, required: false, default: '' }) contextId!: string

  // get videoId () {
  //   if (!this.content) return null
  //   return this.content.data.i18n.video?.value.id
  // }

  get image () {
    if (!this.content) return null
    return this.content.data.image || null
  }

  get mediaSyncId () {
    if (!this.content) return null
    return this.content.data.id
  }

  get title () {
    if (!this.content) return null
    return this.content.data.i18n.title?.value || null
  }

  get description () {
    if (!this.content) return null
    return this.content.data.i18n.description?.value || null
  }

  openMediaSync () {
    this.$router.push({
      name: 'media-sync', 
      params: { uuid: this.mediaSyncId },
      query: { context: 'poi', context_id: this.contextId, content_id: this.content.id }})
  }

  get duration () {
    if (!this.content) return null
    return this.content.data.i18n.medias?.audio?.file.duration
  }
}
